import { Stack } from "@mui/material";
import type { Control, UseFormWatch } from "react-hook-form";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { Resources, useResource } from "Translations/Resources";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  control: Control<CampaignFormData>;
  watch: UseFormWatch<CampaignFormData>;
  isSubmitting: boolean;
};

export const CampaignContentSection = ({
  control,
  watch,
  isSubmitting,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={3}>
      <FormInput
        control={control}
        name="header"
        label={t(RESOURCES.HeaderTitle)}
        fullWidth
        disabled={isSubmitting}
        placeholder={t(RESOURCES.HeaderTitlePlaceholder)}
      />

      <FormInput
        control={control}
        name="description"
        label={t(RESOURCES.Description)}
        fullWidth
        multiline
        rows={6}
        disabled={isSubmitting}
        placeholder={t(RESOURCES.DescriptionPlaceholder)}
        helperText={t(RESOURCES.DescriptionCharCount, {
          count: watch("description")?.length || 0,
        })}
      />

      <FormInput
        control={control}
        name="linkName"
        label={t(RESOURCES.FoundationLinkName)}
        fullWidth
        disabled={isSubmitting}
        placeholder={t(RESOURCES.FoundationLinkNamePlaceholder)}
        helperText={t(RESOURCES.FoundationLinkNameHelper)}
      />

      <FormInput
        control={control}
        name="linkUrl"
        label={t(RESOURCES.FoundationLinkUrl)}
        fullWidth
        disabled={isSubmitting}
        placeholder={t(RESOURCES.FoundationLinkUrlPlaceholder)}
        helperText={t(RESOURCES.FoundationLinkUrlHelper)}
      />
    </Stack>
  );
};
